import { useEffect } from 'react'

const TallyForm = ({ loggedUser }) => {
  const storageKey = `tally-shown-mOrYBK-${loggedUser.pkid}`

  const userId = localStorage.getItem(storageKey)

  useEffect(() => {
    if (parseInt(userId) !== loggedUser.pkid) {
      const script = document.createElement('script')
      script.src = 'https://tally.so/widgets/embed.js'
      script.async = true
      script.onload = () => {
        if (window.Tally) {
          setTimeout(() => {
            window.Tally.openPopup('mOrYBK', {
              layout: 'modal',
              width: 600,
              overlay: true,
              emoji: {
                text: '👋',
                animation: 'wave',
              },
              hiddenFields: {
                email: loggedUser.email,
                tenant: loggedUser.society,
              },
            })
            localStorage.setItem(storageKey, loggedUser.pkid)
          }, 30000)
        }
      }
      document.body.appendChild(script)
    }
  }, [])

  return null
}

export default TallyForm
